import {styled} from '@mui/system'

// NOTE: dimensions are fixed px values (not theme.spacing(n)) on purpose.
// This component is shared by legacy pages and new-style pages, whose themes
// use different spacing base units (legacy: 2, new: 8). Using theme.spacing(n)
// made these filter fields balloon to ~4x their intended size when rendered
// inside ThemeProviderNew (e.g. the "Lista pazienti" filter on Incontri virtuali).
export const FiltersStyled = styled('div')(({theme}) => ({

  '.filter-form': {
    display: 'grid',
    columnGap: '10px',

    '.ant-form-item-label > label': {
      fontSize: 12,
      color: '#222'
    },

    '.ant-input': {
      height: 38,
      paddingTop: 6,
      paddingBottom: 6
    },

    '.ant-input[disabled]': {
      backgroundColor: '#eee',
      borderColor: '#ccc',
      color: '#555'
    },

    '.ant-picker': {
      width: '100%',
      height: 38,
      paddingTop: 6,
      paddingBottom: 6,
      backgroundColor: '#eee'
    },

    '.ant-select': {
      width: '100%',

      '.ant-select-selector': {
        height: 38,
        paddingTop: 6,
        paddingBottom: 6,
        borderRadius: 42,

        '.ant-select-selection-placeholder': {
          lineHeight: 'unset'
        },

        '.ant-select-selection-item': {
          lineHeight: 'unset'
        },

        '.ant-select-selection-overflow': {
          height: 30,
          flexWrap: 'nowrap',
          marginTop: '-5px',
          whiteSpace: 'nowrap',
          borderRadius: '32px',
          overflow: 'hidden',
          '.ant-tag': {
            borderRadius: '16px'
          },
          '.ant-select-selection-item': {
            borderRadius: '16px',
            paddingTop: '2px'
          },
          '.ant-select-selection-item-content': {
            marginRight: 0,
            fontSize: '12px'
          }
        }
      }
    }
  },

  '.user-content': {
    display: 'flex',

    '.user-buttons': {
      display: 'flex',

      '.user-button': {
        color: theme.palette.neutral.main,
        borderRadius: 42,
        minWidth: 34,
        height: 42,
        '&:hover': {
          backgroundColor: theme.palette.neutral[200]
        }
      }
    }
  },

  '.footer-div': {
    display: 'flex',
    justifyContent: 'flex-end',

    button: {
      margin: 4
    }
  }
}))
